import Utils from "./utils.class";

const { jQuery: $ } = window;

export default class TabbedNav {
    #$header;
    #$nav;
    #$menuItem;
    #$submenus;
    #utils;

    constructor(utils) {
        this.#utils = utils;
        this.#$header = $(".menu-elements__tab-row");
        this.#$nav = this.#$header.find(".menu-elements__tab-row");
        this.#$menuItem = this.#$header.find('.menu-elements__tab-group-wrap');
        this.#$submenus = this.#$header.find('.menu-elements__tabRowContainer');
    }

    events() {
        const me = this;
        // height variable for stytling
        $(".menu-elements__tab-row").each(function () {
            const tabID = this.id;
            const subCont = $(this).children('.menu-elements__tabRowContainer').first();

            // Pull the Menu items out and put them in the content container
            $(this).find('.menu-elements__tab-group-wrap').each(function () {
                const $dataAtt = $(this).data('box'); //Grab Unique identifier
                $(this).children(".sub-menu")[0].dataset.content = ($dataAtt) //Add unique identifier to submenu
                $(this).children(".sub-menu")[0].className += " menu-elements__tabRowContent" //Add unique class to submenu
                subCont.append($(this).children(".sub-menu")[0])
            });

            Utils.equalHeight('.menu-elements__row', '.menu-elements__tabRowContainer');
            Utils.equalHeight('.menu-elements__tab-group', '.menu-elements__tab-row > .sub-menu');

            $(this).find(".menu-elements__tab-group").first().addClass("js-active");
            $(this).find(".menu-elements__tabRowContent").first().addClass("js-active");

            let elCount = $(this).find('.menu-elements__tab-group').length
            elCount = 100 / elCount;

            $(this).find(".menu-elements__tab-group").each(function () {
                $(this).css({"flex": `1 1 ${elCount}%`});
                const elHeight = ($(this).height() / 2) - 2;
                $(this).css({"--arrow-size": `${elHeight}px`});
            })

            // Handles toggling js-active for tab and content box
            $(this).find('.menu-elements__tab-group-wrap').on('mouseover', function () {
                $(this).closest('.sub-menu').children().removeClass("js-active"); //Remove active from all tabs
                const $dataAtt = $(this).data('box'); //Grab unique dataset
                if ($(this).parent().is(".menu-item-has-children")) {
                    $(this).parent().addClass("js-active");
                }

                $(this).closest('.sub-menu').siblings('.menu-elements__tabRowContainer').children().each(function () {
                    $(this).removeClass("js-active");
                    if ($(this).data("content") === $dataAtt) {
                        $(this).addClass("js-active");
                    }
                })
            });

        })
    }
}